import request from '../utils/request';

export const fetchBannerList = params =>
  request.get('/admin/banner/list', { params });
export const createBanner = data => request.post('/admin/banner/add', data);
export const updateBanner = (id, data) =>
  request.put(`/admin/banner/update/${id}`, data);
export const updateBannerGroup = (title, data) =>
  request.put(`/admin/banner/group/${encodeURIComponent(title)}`, data);
export const reorderBanners = orders =>
  request.post('/admin/banner/reorder', { orders });
export const deleteBanner = id => request.delete(`/admin/banner/delete/${id}`);
export const uploadBannerImage = data =>
  request.post('/admin/upload/image', data, { timeout: 120000 });
